import { useUserContext } from '../../utils/UserContext';
import { Trans } from '@lingui/react/macro';
import Chip from '@mui/material/Chip';
import { useAtomValue, useSetAtom } from 'jotai';
import { adminDebugSessionAtom } from '../../global-atoms/adminDebugSessionAtom';

export function DebugSessionIndicator() {
  const { loginAsUser } = useUserContext();
  const isVisible = !!loginAsUser;

  const isDebugSession = useAtomValue(adminDebugSessionAtom);
  const setDebugSession = useSetAtom(adminDebugSessionAtom);

  if (!isVisible) {
    return null;
  }

  return (
    <Chip
      label={
        <Trans>Debugging: {isDebugSession ? 'Enabled' : 'Disabled'}</Trans>
      }
      sx={(theme) => ({
        backgroundColor: isDebugSession
          ? theme.palette.success.main
          : theme.palette.error.main,
        color: theme.palette.primary.contrastText,
      })}
      onClick={() => setDebugSession(!isDebugSession)}
    />
  );
}
